import gql from 'graphql-tag';

/**
 * Data of the block project-customer-master-data: the eighteen master-data fields on `customer`
 * and the net-registration requirements for the badges. Read through
 * `Project.blocks.customerMasterData`, which checks the block's read permission.
 */
export const PROJECT_CUSTOMER_MASTER_DATA_FIELDS = gql`
  fragment projectCustomerMasterDataFields on ProjectCustomerMasterDataBlock {
    id
    number
    customer {
      salutation
      company
      firstname
      lastname
      street
      streetNumber
      streetNumberSuffix
      zip
      city
      cityPart
      phone
      phone2
      phone3
      mobile
      mobile2
      email
      email2
      birthdayAt
    }
    netRegistrationRequirements {
      name
      fullfilledState
    }
  }
`;
